/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Capability_Desk_TitleInputs */

const en_landing_capability_desk_title = /** @type {(inputs: Landing_Capability_Desk_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empower Sales & Trading`)
};

/**
* | output |
* | --- |
* | "Empower Sales & Trading" |
*
* @param {Landing_Capability_Desk_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_capability_desk_title = /** @type {((inputs?: Landing_Capability_Desk_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Capability_Desk_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_capability_desk_title(inputs)
});